import React, { forwardRef } from 'react';
import { Button, ButtonProps } from '@mui/material';

export interface AlertButtonProps extends ButtonProps {}

/**
 * AlertButton is a proxy component to <Button variant="text" color="white" size="small" />
 */
export const AlertButton: React.FC<AlertButtonProps> = forwardRef((props, ref) => {
  return <Button ref={ref} variant="text" color="white" size="small" {...props} />;
});
